module.exports = __webpack_public_path__ + "static/media/real-time-visibility.3e97c3c8.svg";